module.exports = __webpack_public_path__ + "assets/img/bannerBg.fbe25036.png";